<template>
    <div class="tag-panel">
        <div  class="tag-group left fade">
            <button v-if="dpp.isActive && !dpp.isRentals" id="virtualTour" class="tag springgreen newtag tag--mobile" @click="openVirtualTour">
                {{dpp.rdcMoveinReady === false ? 'TO BE BUILT': molang('dpp.propertyTag.virtualTour')}}
            </button>
            <div v-else-if="gethousestatus" class="tag active tag--mobile">{{ gethousestatus }}</div>
            <div class="tag brand active" v-if="dpp.localHighlight && dpp.localHighlight.waterbodyDist && dpp.localHighlight.waterbodyDist < 0.1">
               {{molang('dpp.propertyTag.lakefront')}}
            </div>
            <div class="tag brand active" v-if="dpp.localHighlight && dpp.localHighlight.shorelineDist && dpp.localHighlight.shorelineDist < 0.1">
               {{molang('dpp.propertyTag.waterfront')}}
            </div>
            <div class="tag brand active" v-if="dpp.listingByMovoto">
                <template v-if="dpp.isSold">
                    {{molang('dpp.propertyNearby.soldBy')}}
                </template>
                <template v-else>
                    {{molang('dpp.propertyNearby.listedBy')}}
                </template>
            </div>
            <button type="button" data-allow-mismatch="text" class="tag brand active newtag openhouse tag--mobile" v-if="dpp.openDate" @click="popOpenHouse">
               {{molang('search.card.open')}} <span class="value">{{dpp.openDate}}</span>
            </button>
            <div class="f7 text-white" style="width:100%;" v-if="showAgentTag() && (dpp.listingAgent || dpp.officeListName) && !dpp.showAsPR">
                <div :class="showAgentContactTag() ? 'attr-text' : ''" >
                    <span>
                        <img class="dpp-mlslogo" loading="lazy"  v-if="dpp.mlsLogoSrc && shouldShowHistoryLogo()" :src="dpp.mlsLogoSrc" :alt="dpp.mlsDescription" />
                        <span>
                            <template v-if="dpp.listingAgent && dpp.officeListName">
                                {{dpp.listingAgent}} of {{ dpp.officeListName}}
                            </template>
                            <template v-else>
                                {{dpp.listingAgent || dpp.officeListName}}
                            </template>
                        </span>
                    </span>
                    <span class="agentContact">
                        <template v-if="showAgentContactTag() && dpp.agentDetails && dpp.agentDetails.agentContactInfo">
                            {{dpp.agentDetails.agentContactInfo}}
                        </template>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./property-tags.js"></script>

<style lang="scss">
@use "./property-tags.scss" as *;
</style>

